import { captureException } from "../services/exception-logger"
import { NextActionResponseType, NextActionType } from "./payment-methods"

export const formatNextAction = (
  r: NextActionResponseType
): NextActionType | null => {
  if ("stripe" in r) return { providerName: "stripe", ...r.stripe }
  if ("transpayrent" in r)
    return { providerName: "transpayrent", ...r.transpayrent }
  if ("vipps_mobilepay" in r)
    return { providerName: "vipps_mobilepay", ...r.vipps_mobilepay }
  if ("mobilepay_dk" in r)
    return { providerName: "mobilepay_dk", ...r.mobilepay_dk }
  if ("adyen" in r) return { providerName: "adyen", ...r.adyen }
  if ("adyen_custom" in r)
    return { providerName: "adyen_custom", ...r.adyen_custom }
  if ("pensopay" in r) {
    return { providerName: "pensopay", ...r.pensopay }
  }
  if ("epay" in r) {
    return { providerName: "epay", ...r.epay }
  }

  captureException(
    new Error(
      `Unknown next action type in formatNextAction: ${JSON.stringify(r)}`
    ),
    {
      type: "business_logic",
      category: "unsupported-operation",
      context: { errorSource: "formatNextAction" },
    }
  )
  return null
}

export const getUnformattedNextAction = (nextAction: NextActionType) => {
  const { providerName, ...rest } = nextAction
  return rest
}
